import { render, staticRenderFns } from "./AllGlLevel1.vue?vue&type=template&id=7b1c013a&"
import script from "./AllGlLevel1.vue?vue&type=script&lang=js&"
export * from "./AllGlLevel1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports